import React from 'react'
import { useComment } from '../../../Hook/App';
import Spinner from '../../../Components/Spinner'
function Comments({ comments }) {
    const { Loading, onChange, form, sendReplay, setId } = useComment();
    const Item = ({ comment }) => {



        const Stars = () => {

            let JSX = [];

            for (let index = 0; index < 5; index++) {
                JSX.push(<i style={{ color: (comment.score / 20) > index ? "#fc3" : "#ccc" }} class=" fas fa-star"></i>);
            }

            return JSX

        }

        return (
            <div className="comment">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="align-items-center d-flex">
                        <i class="fas fa-thumbs-up"></i>
                        <div className="line light-text">{comment.user && comment.user.name}</div>
                        <span className="light-text">{new Date(comment.created_at).toLocaleDateString('fa')}</span>
                    </div>
                    <div className="d-flex" style={{ direction: 'ltr' }}>
                        <Stars />
                    </div>
                </div>
                <div className="d-flex mb-3">
                    <span className="light-text">برای</span>
                    <span className="margin">{comment.item && comment.item.name}</span>
                </div>
                <p>{comment.comment}</p>
                {comment.answer &&
                    <>
                        <span className='d-block mx-2 mb-2'>پاسخ</span>
                        <p className='ms-3'>{comment.answer}</p>
                    </>
                }
                <div className="usercomment-footer d-flex justify-content-center">
                    <div className="line light-text d-flex">
                        <small> امتیاز کل {(comment.score / 20)} از 5</small>
                    </div>
                    <div className="line light-text d-flex">
                        <small>  سرعت پاسخگویی {(comment.speed / 20)} از 5</small>
                    </div>
                    <div className="light-text d-flex">
                        <small>   صحت اطلاعات {(comment.verify / 20)} از 5</small>
                    </div>
                </div>
                {comment.answer ? null :
                    <div className="replay" data-bs-toggle="modal" onClick={() => { setId(comment.id) }} data-bs-target="#exampleModal">
                        <i class="fas fa-reply"></i>
                        <span>پاسخ به این نظر</span>
                    </div>
                }
            </div>
        )
    }

    return (
        <div className='profile-bottom' style={{ paddingBottom: '13rem' }}>
            <div className="number text-center">{comments.total} نظر</div>
            {
                comments && comments.data &&
                comments.data.map((comment, i) => {
                    return <Item comment={comment} key={i} />;
                })
            }

            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">پاسخ به نظر</h5>
                            <button type="button" id='closeBB' class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div className="replay-main">
                                <textarea name="answer" rows="5" onChange={onChange} >{form.answer}</textarea>
                                <div className="justify-content-end d-flex">
                                    <button disabled={Loading} onClick={sendReplay} className="btn text-white" >{Loading ? <Spinner sm /> : "ثبت پاسخ"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Comments